import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FavoriteCardTypeEnum, UserFavoriteCardData } from '../../../user-favorite-data.model';

@Component({
  selector: 'favorite-cta',
  template: `
    <div class="eva-3-offer-card content {{cardType}}">
      <h3 class="title">{{ data.link.title | translate }}</h3>

      <button
        class="eva-3-btn-ghost -md -circle"
        name="favorite-cta-btn"
        (click)="handleButtonClick()"
      >
        <i class="eva-3-icon-chevron-right -eva-3-icon-xsm btn-icon"></i>
      </button>
    </div>
  `,
  styleUrls: ['./favorite-cta.component.scss'],
})
export class FavoriteCtaComponent {
  @Input() data: UserFavoriteCardData;
  @Input() onClick = new EventEmitter();
  @Input() cardType: FavoriteCardTypeEnum;

  FavoriteCardTypeEnum = FavoriteCardTypeEnum;

  handleButtonClick() {
    this.onClick.emit();
  }
}
